module.exports = __webpack_public_path__ + "img/sabbatical-beauty_thumbnail.556dadc2.png";